<template>
  <div v-if="IS_BAND" class="navContextMenuArtistWrapper">
    <div v-if="IS_LOGGED_IN && IS_AGENCY" class="paddedWrapper">
      <div class="borderedWrapper">
        <band_select class="fitBandSelect" />
      </div>
    </div>
    <div class="infos">
      <span class="title">{{ $t("band.RPMenu.account") }}</span>
    </div>
    <nuxt-link class="navBaseElem paddedElem" to="/agency/favorites/">
      <span class="text">{{ $t("layout.menu.menu00") }}</span>
    </nuxt-link>
    <div @mouseover="hover = true" @mouseout="hover = false">
      <nuxt-link class="navBaseElem paddedElem" to="/band/shop/">
        <span class="text">{{ $t("layout.menu.menu01") }}</span>
        <div class="fairRight">
          <span class="balance">{{ balance }}</span>
          <img class="grooviesIcon" src="/media/grooviz_light_grey.svg" />
        </div>
      </nuxt-link>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex"

import band_select from "./band/bandSelect"

export default {
  components: {
    band_select,
  },
  data: function () {
    return {
      hover: false,
    }
  },
  computed: {
    ...mapState({
      kind: (state) => state.user.agency.kind,
      balance: (state) => state.user.grooviz,
    }),
    ...mapGetters({
      IS_BAND: "user/IS_BAND",
      IS_AGENCY: "user/IS_AGENCY",
      IS_LOGGED_IN: "user/IS_LOGGED_IN",
    }),
  },
}
</script>

<style scoped src="~/components/nav/loggedIn/navBaseElem.css"></style>
<style scoped>
.navContextMenuArtistWrapper {
  position: relative;
  width: 100%;
}

.borderedWrapper {
  display: flex;
  flex-direction: column;
  padding: 20px 0px;
  border-top: 1px solid var(--color-light-grey);
  border-bottom: 1px solid var(--color-light-grey);
}

.paddedWrapper {
  padding: 0px 20px;
  margin: 20px 0px 0px 0px;
}

.infos {
  display: flex;
  flex-direction: column;
}

.title {
  font-family: EuclidFlex;
  font-weight: 500;
  font-size: var(--font-size-title-nano);
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 12px;
}

.text {
  color: var(--color-black);
  font-size: var(--font-size-small);
  font-weight: 500;
}

.subtitle {
  font-size: var(--font-size-small);
  color: var(--color-storm-grey);
}

.euclid {
  font-family: EuclidFlex;
  font-weight: 700;
  margin-left: 4px;
}

.navBaseElem.balance {
  font-size: var(--font-size-eleven);
  color: var(--color-darker-grey);
  font-weight: 500;
}

.grooviesIcon {
  margin-left: 4px;
  width: 12px;
  height: 12px;
}

@media screen and (min-width: 768px) {
  .title {
    font-size: var(--font-size-big);
  }
}
</style>
